import type { ActionCreator, AnyAction } from 'redux'

import { actionTypes } from 'actions/actionTypes'
import { canPayWithGooglePay } from 'actions/trackingKeys'

export const trackCanPayWithGooglePay: ActionCreator<AnyAction> = () => ({
  type: actionTypes.TRACKING,
  trackingData: { actionType: canPayWithGooglePay },
})
